import React, { useRef } from 'react';
import { motion, useAnimationFrame, useMotionValue, useScroll, useSpring, useTransform, useVelocity, wrap } from 'framer-motion';

/* Endless text strip that speeds up, reverses and skews with scroll velocity */
export default function VelocityMarquee({ items, baseVelocity = -2.2, className = '' }) {
  const base = useMotionValue(0);
  const { scrollY } = useScroll();
  const vel = useSpring(useVelocity(scrollY), { damping: 50, stiffness: 400 });
  const factor = useTransform(vel, [-1000, 0, 1000], [-4, 0, 4], { clamp: false });
  const skew = useTransform(vel, [-1500, 1500], [8, -8]);
  const dir = useRef(1);
  const x = useTransform(base, (v) => `${wrap(-25, -50, v)}%`);

  useAnimationFrame((_, delta) => {
    let move = dir.current * baseVelocity * (delta / 1000);
    const f = factor.get();
    if (f < 0) dir.current = -1; else if (f > 0) dir.current = 1;
    move += dir.current * move * f;
    base.set(base.get() + move);
  });

  const row = (
    <>
      {items.map((t, i) => (
        <span key={i} className={`vm-item${i % 2 ? ' outline' : ''}`}>{t}<i className="vm-star" aria-hidden="true">✦</i></span>
      ))}
    </>
  );
  return (
    <div className={`vmarquee ${className}`} aria-hidden="true">
      <motion.div className="vm-track" style={{ x, skewX: skew }}>
        {row}{row}{row}{row}
      </motion.div>
    </div>
  );
}
